import React, { useEffect } from 'react';  
import { Redirect, Route } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as staticConfigs from '../utilities/staticConfigs';
import { getStorage } from '../utilities/browserStorage';
import checkPermissionMiddleware from './permissionCheckMiddleware';
import NoPermission from "../components/NoPermissionPage/NoPermission";
import { clearIndexedDb } from '../utilities/commonUtilities';

const PrivateRoute = ({ component: Component, ...rest }) => {
    const dispatch = useDispatch();
    const locationPath = rest.location.pathname;
    
    const isPasswordExpired = getStorage('passwordExpired');
    const userData = JSON.parse(getStorage('userData') || 'null');
    const userGroupToken = userData?.accessToken ?? null;

    useEffect(() => {
        if (!userGroupToken) {
            clearIndexedDb();
            // Reset logic here...
            dispatch({ type: 'commonStates/reset' }); 
        }
    }, [userGroupToken, dispatch]);

    // 1. If not logged in, go to Login
    if (!userGroupToken) {
        return <Redirect to={staticConfigs.LOGIN_ROUTE_SUPER || "/"} />;
    }

    // 2. If password expired, go to reset
    if (isPasswordExpired) {
        return <Redirect to={staticConfigs.ROUTE_FORCE_RESET_PASSWORD} />;
    }

    // 3. Check Permissions
    const hasPermission = checkPermissionMiddleware(locationPath);
    
    return (
        <Route 
            {...rest} 
            render={(props) => (
                hasPermission ? <Component {...props} /> : <NoPermission />
            )} 
        />
    );
};

export default PrivateRoute;